import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";

const LINKS = [
  { href: "#standards", label: "Standards" },
  { href: "#approach", label: "Approach" },
  { href: "#solutions", label: "Solutions" },
  { href: "#proof", label: "Proof" },
  { href: "#faq", label: "FAQ" },
  { href: "/blog", label: "Blog" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="hvm-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled ? "bg-[#0B0F17]/90 backdrop-blur-md border-[#26334D]" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="navbar-brand" className="flex items-center gap-3">
          <img src="/accessx-logo-white.png" alt="Access X Oceania logo" width="239" height="56" className="h-14 w-auto" />
          <span className="font-tech text-xs tracking-[0.25em] uppercase text-[#F4A031] border border-[#F4A031]/40 px-2.5 py-1 clip-notch-sm">
            HVM
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-tech text-xs tracking-[0.2em] uppercase text-[#94A3B8] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-5">
          <div className="flex flex-col gap-1">
            <a
              href="tel:0800322269"
              data-testid="nav-phone"
              className="flex items-center gap-2 font-tech text-[10px] tracking-widest text-[#94A3B8] hover:text-[#F4A031] transition-colors"
            >
              <Phone size={12} /> NZ 0800 322 269
            </a>
            <a
              href="tel:1800284339"
              data-testid="nav-phone-au"
              className="flex items-center gap-2 font-tech text-[10px] tracking-widest text-[#94A3B8] hover:text-[#F4A031] transition-colors"
            >
              <Phone size={12} /> AU 1800 284 339
            </a>
          </div>
          <a
            href="#assessment"
            data-testid="nav-cta-assessment"
            className="bg-[#F4A031] hover:bg-[#D98A1F] text-[#0B0F17] font-grotesk font-bold text-sm px-5 py-2.5 clip-notch-sm transition-colors"
          >
            Request Site Assessment
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-[#0B0F17]/95 backdrop-blur-md border-t border-[#26334D] px-5 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => setOpen(false)}
              className="font-tech text-sm tracking-[0.2em] uppercase text-[#94A3B8]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#assessment"
            data-testid="nav-mobile-cta"
            onClick={() => setOpen(false)}
            className="bg-[#F4A031] text-[#0B0F17] font-grotesk font-bold text-sm px-5 py-3 clip-notch-sm text-center"
          >
            Request Site Assessment
          </a>
        </motion.div>
      )}
    </header>
  );
};
